module.exports = __webpack_public_path__ + "media/src/images/partners/unep-19b1db6b8ebf2dfcc3e2fb0bfe4b2ed9.jpg";